export default function PasswordFields({ values, onChange }) {
  return (
    <>
      <label>
        Current password
        <input required type="password" autoComplete="current-password" value={values.currentPassword} onChange={(event) => onChange("currentPassword", event.target.value)} data-testid="admin-current-password-input" />
      </label>
      <label>
        New password
        <input required type="password" autoComplete="new-password" value={values.newPassword} onChange={(event) => onChange("newPassword", event.target.value)} data-testid="admin-new-password-input" />
      </label>
      <label>
        Confirm new password
        <input required type="password" autoComplete="new-password" value={values.confirmPassword} onChange={(event) => onChange("confirmPassword", event.target.value)} data-testid="admin-confirm-password-input" />
      </label>
    </>
  );
}